import { Injectable } from '@angular/core';

@Injectable({

  providedIn: 'root'

})

export class StateManagementMenucarService {

  filterItem_Management = [];

  searchKey_Management!: string | number | any;

  radioButton_Management !: number;

  selectBox_Management !: string;

  geoFence_Management!: any;

  bOfficial: boolean = false;

  constructor() { }

}
